/**
 * `Sergeant Meatball`: a rank, then a noun.
 *
 * Narrower than the adjective shape and deliberately so. It reads as a call sign, which is the
 * register a shooter's lobby already sits in, and the joke is that nothing about the noun deserves
 * the rank.
 */

import { ABSURD_NOUNS } from '@/identity/nameWords/absurdNouns';
import { MOCK_RANKS } from '@/identity/nameWords/mockRanks';
import type { NamePattern, WordPicker } from '@/identity/playerNameContract';

export const RANK_NOUN: NamePattern = {
  id: 'rankNoun',
  build(pick: WordPicker): string {
    return `${pick(MOCK_RANKS)} ${pick(ABSURD_NOUNS)}`;
  },
};
